export default {
  nameCol: {
    width: 130,
  },
  addressCol: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  actionCol: {
    width: 150,
    textAlign: 'right',
  },
  noData: {
    fontSize: 200,
    color: 'lightgrey',
  },
  add: {
    position: 'absolute',
    left: 5,
    top: 5,
    zIndex: 1,
  },
};



// WEBPACK FOOTER //
// ./src/components/Addresses/AddressesGrid/styles.js